module.exports = {
      id: "404-robot-usage",
      viewBox: "0 0 280 313",
      url: __webpack_public_path__ + "svg-sprite-3bd5c44086b3ee01fb1a36f6e1306c3d.svg#404-robot",
      toString: function () {
        return this.url;
      }
    }